import { getAllUrlParams } from '@hll/driver-js-utils';
import { ClientUtil } from '@xl/js-utils';

export const getFormatDate = function dateFormat(fmt, date) {
  let ret;
  // date = date.replace(/-/g, '/');
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
      );
    }
  }
  return fmt;
};
export const isBefore = function(time) {
  const time_now = new Date();
  const time_target = new Date(time.replace(/-/g, '/')).getTime();
  return time ? time_now < time_target : false;
};

// 判断是否在端内
export const isInAppFn = function() {
  // 优先采用 UA 判断
  const ua = navigator.userAgent;
  // 小拉出行 xiaolachuxing | 企业包（测试）需要 cn.huolala
  if (/(com.xiaolachuxing|cn.huolala).\S+/i.test(ua)) {
    return true;
  }
  // 其次用链接 url 判断
  const allUrlParams = getAllUrlParams(window.location.href);
  const { revision } = allUrlParams;
  if (revision) {
    return true;
  }

  return false;
};

/**
 *
 * @param {Object} params 传进来的对象
 */
function toQueryString(params = {}) {
  let result = '';

  for (const key in params) {
    result += `&${key}=${params[key]}`;
  }

  return result;
}

// 对 mainUrl 剔除部分参数后，再拼接追加的部分
// 可以保证追加的参数字段能覆盖原有的同名参数字段
function joinFullUrl(mainUrl, excludeParams, appendStr) {
  const params = excludeParams || {};
  const url = (mainUrl || '').replace(/([^#&=?]+)(=([^#&]*))/g, (match, p1) => {
    if (p1 in params && params[p1] != null) {
      return '';
    }

    return match;
  });

  return `${url}${!url.includes('?') ? '?' : ''}${appendStr}`;
}

/**
 *
 * @param {String} url 原始url链接
 * @param {Object} params 要拼接的参数对象
 * @return {String} 返回拼接参数后的链接
 *
 * NOTE: search 部分和 hash 部分都会拼上参数，并对同名参数做覆盖
 */
export function addParamsToUrl(url, params) {
  if (!url || !params) {
    return url || '';
  }

  const paramsStr = toQueryString(params);

  // hash 路由模式，或纯锚点链接，拼在'#'号之前
  if (url.includes('#')) {
    const [mainPart, hashPart] = url.split('#');

    // hash 部分也追加参数
    const hashUrl = joinFullUrl(hashPart || '', params, paramsStr);

    return joinFullUrl(mainPart, params, `${paramsStr}#${hashUrl}`);
  }

  return joinFullUrl(url, params, paramsStr);
}

export function getDiffDay(startDate, endDate) {
  // 计算两个日期之间的差值
  const sDate = Date.parse(startDate);
  const eDate = Date.parse(endDate);
  // 将两个日期都转换为毫秒格式，然后做差
  const diffDate = Math.abs(sDate - eDate); // 取相差毫秒数的绝对值
  const days = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
  if (sDate > eDate) {
    return `-${days}`;
  }
  return days; // 相差的天数
}

// 对象下划线属性转小驼峰
export function lineToHump(data) {
  if (typeof data !== 'object' || !data) return data;
  const newObj = {};
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const newKey = key.replace(/_([a-z])/g, (res) => res[1].toUpperCase());
      newObj[newKey] = lineToHump(data[key]);
    }
  }
  return newObj;
}

// 计算年龄
export const getAge = (birthday) => {
  const birth = new Date(birthday?.replace(/-/g, '/'));
  if (!birth || !birth.getTime()) {
    return 0;
  }
  const now = new Date();
  const age = now.getFullYear() - birth.getFullYear();
  if (
    now.getMonth() < birth.getMonth() ||
    (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())
  ) {
    return age - 1;
  }
  return age;
};

export const pxToVw = function(px) {
  return document.documentElement.clientWidth * px / 375;
};

// 判断是否全面屏
export function judgeFullScreen() {
  const rate = window.screen.height / window.screen.width;
  const limit = window.screen.height === window.screen.availHeight ? 1.8 : 1.65;
  return rate > limit;
}

export const getDaysUnit = (days) => {
  return days == 30 ? '月' : days == 90 ? '季' : '';
};

const getDriverAppVersion = () => {
  const match = navigator.userAgent.match(/\/[a-z]+\((\d{4}),(android|ios)/);
  return isInAppFn() && match ? +match[1] : null;
};

// 设置页面标题
export const setTitle = (title, style) => {
  document.title = title;
  // app内，设置app标题栏， 一定要延时，不然ios返回会显示加载中
  if (isInAppFn()) {
    setTimeout(() => {
      console.log(getDriverAppVersion(), 'version');
      if (getDriverAppVersion() >= 1036) {
        // 下个版本 1034生效
        if (!style) {
          ClientUtil.webcall({
            action: 'setTitle',
            title,
          });
        } else {
          console.log('触发action toolbar_control', style);
          ClientUtil.webcall({
            action: 'toolbar_control',
            msg: title,
            style: style, // navigation or home
          });
        }
      } else {
        // 之前版本
        ClientUtil.webcall({
          action: 'setTitle',
          title,
        });
      }
    }, 0);
  }
};
